exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".createFactContainer[data-v-25b189ca]{padding:30px;width:500px;font-family:Roboto,sans-serif}.factInput[data-v-25b189ca]{width:300px;padding:10px;border-radius:4px;border:none;position:relative;top:10px;outline:none}.charRemaining[data-v-25b189ca]{position:relative;top:20px;color:grey}.progressBarCont[data-v-25b189ca]{display:flex;align-items:center;justify-content:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-25b189ca","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/assets/Dynamic/createPages/createRandomFact.vue
// module id = 437
// module chunks = 0